import React from 'react';
import classnames from 'classnames';

import Button from 'ui/common/button';

import styles from './index.module.scss';

const SolutionCards = () => (
  <div className={classnames(styles.cards)}>
    <div className={classnames(styles.card)}>
      <div className={classnames(styles.cardImage)}>
        <img src={'/upskilling.svg'} alt="new-role" width="80" />
      </div>
      <div className={classnames(styles.cardTitle)}>Upskilling</div>
      <div className={classnames(styles.cardText)}>
        L&D doesn’t need to be complicated anymore! Future-proof your workforce through
        assessment-driven learning and expert peer assessments.
      </div>
      <div className="text-center mt-4">
        <Button color="primary-rect" href="https://indorse.io/upskilling">
          Request Demo
        </Button>
      </div>
    </div>
    {/* <div className={classnames(styles.card)}>
      <div className={classnames(styles.cardImage)}>
        <img src={"/icons/metamorph-icon.svg"} alt="new-role" width="80" />
      </div>
      <div className={classnames(styles.cardTitle)}>Metamorph by Indorse</div>
      <div className={classnames(styles.cardText)}>
        Measure the performance & productivity of your remote software
        engineering team with a tool they'll love - Metamorph!
      </div>
      <div className="text-center mt-4">
        <Button href="https://indorse.io/metamorph">Start Free Trial</Button>
      </div>
      <div className={classnames(styles.new)}>NEW</div>
    </div> */}
    <div className={classnames(styles.card)}>
      <div className={classnames(styles.cardImage)}>
        <img src={'/hackathons.svg'} alt="new-role" width="80" />
      </div>
      <div className={classnames(styles.cardTitle)}>Online Hackathons</div>
      <div className={classnames(styles.cardText)}>
        Attract & find top tech talent, initiate crowdsourced innovation, and increase brand
        awareness; all on one push of a button.
      </div>
      <div className="text-center mt-4">
        <Button color="primary-rect" href="https://indorse.io/hackathons">
          Request Demo
        </Button>
      </div>
    </div>
  </div>
);

const Products = () => {
  return (
    <div className={classnames(styles.blueBackground)}>
      <div className={classnames('page-max-width')}>
        <div>
          <h2 className={classnames(styles.title)}>Indorse Products</h2>
          <h3 className={classnames(styles.subtitle)}>
            Successful tech teams drive successful businesses
          </h3>
          <SolutionCards />
        </div>
      </div>
    </div>
  );
};

export default Products;
